import * as React from "react";
import { UitkSelect } from "uitk-react-select";
import { CouponCodeDropdownProps } from "components/flexComponents/WizardCarPWA/typings";
import { locKeys } from "components/flexComponents/WizardCarPWA/components/l10n";
import { UitkLayoutGridItem } from "uitk-react-layout-grid";
import { observer } from "mobx-react";
import { useLocalization } from "@shared-ui/localization-context";
import { CarVendorInformation } from "src/stores/wizard/config/staticConfigs/car/typings";
import { couponCodeTypes } from "./CouponCodeTypes";

export const CouponCodeDropdown = observer((props: CouponCodeDropdownProps) => {
  const { formatText } = useLocalization();
  const { noCode, corporateCode, specialCode } = locKeys;
  const { NO_CODE, CORPORATE_CODE, SPECIAL_CODE } = couponCodeTypes;
  const noReferenceVendor: CarVendorInformation = props.carWizardState.config.vendors.NO_PREFERENCE;

  if (!props.carWizardState.preferredBrand || props.carWizardState.preferredBrand === noReferenceVendor.vendorCode) {
    return null;
  }

  return (
    <UitkLayoutGridItem colSpan={props.colSpan}>
      <div>
        <UitkSelect
          aria-label={props.label}
          label={props.label}
          onChange={props.carWizardState.updateCouponCodeType}
          value={props.carWizardState.carCouponCodeType}
        >
          <option value={NO_CODE}>{formatText(noCode)}</option>
          <option value={CORPORATE_CODE}>{formatText(corporateCode)}</option>
          <option value={SPECIAL_CODE}>{formatText(specialCode)}</option>
        </UitkSelect>
      </div>
    </UitkLayoutGridItem>
  );
});
